module.exports = __webpack_public_path__ + "img/leaders-of-la.5e5d4f3b.jpg";